import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'vwtech-libs',
});

export const componentsManagerPageRouteRef = createRouteRef({
  id: 'vwtech-libs-components-manager',
});

export const landscapeManagerPageRouteRef = createRouteRef({
  id: 'vwtech-libs-landscape-manager',
});
